'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { StepForm } from '../StepForm';
import { BeehiivForm } from '../CallToActionForm/BeehiivForm';
import Modal from 'react-modal';

import { SessionContext } from '@benzinga/session-context';
import { UserManager } from '@benzinga/user-manager';

export interface AltsFormProps {
  email?: string;
}

type AltsFormStep = 'accreditation_status' | 'alternative_assets_allocation' | 'complete';

export const AltsForm: React.FC<AltsFormProps> = () => {
  const [email, setEmail] = React.useState<string>();
  const [showModal, setShowModal] = React.useState<boolean>(false);

  const [currentStep, setCurrentStep] = React.useState<AltsFormStep>('accreditation_status');
  const [accreditationStatus, setAccreditationStatus] = React.useState<string>();

  const session = React.useContext(SessionContext);
  const userManager = session.getManager(UserManager);

  const handleCloseModal = React.useCallback(() => {
    setShowModal(false);
  }, []);

  const updateHubspotProperty = async (email: string, name: string, value: any) => {
    // /user/property
    console.log(email, name, value);
    return await userManager.updateProperty(email, name, value);
  };

  if (!email) {
    return (
      <AltsFormContainer>
        <BeehiivForm
          onSuccess={(message, email) => {
            console.log(message);
            setEmail(email);
            setShowModal(true);
          }}
          pub_id="bede23bb-0f71-43c1-911c-feda9088ad30"
        />
        {/* <HubspotForm
          hubspotFormId="a8baaf46-e2bb-48a9-811f-1501949c7695"
          onSuccess={(message, email) => {
            console.log(message);
            setEmail(email);
            setShowModal(true);
          }}
        /> */}
      </AltsFormContainer>
    );
  }

  if (currentStep === 'complete') {
    return (
      <AltsFormContainer>
        <div className="success-text">Keep an eye on your inbox for exclusive offers!</div>
      </AltsFormContainer>
    );
  }

  return (
    <AltsFormContainer>
      <Modal
        isOpen={showModal}
        onRequestClose={handleCloseModal}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        style={{
          content: {
            border: 'none',
            bottom: 'auto',
            left: '50%',
            marginRight: '-50%',
            maxHeight: '100%',
            padding: '12',
            right: 'auto',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          },
          overlay: {
            background: 'rgba(51, 51, 51, 0.35)',
          },
        }}
      >
        <StepForm
          currentStep={currentStep}
          onStepComplete={(step, option) => {
            console.log(option);
            updateHubspotProperty(email, step.name, option.name).then();
            if (step.name === 'accreditation_status') {
              setAccreditationStatus(option.name);
              setCurrentStep('alternative_assets_allocation');
            } else if (step.name === 'alternative_assets_allocation') {
              // Forward to search page
              window.open(
                `https://www.benzinga.com/alternative-investments/real-estate?investorType=${accreditationStatus}&minimumInvestment[]=0,${option.value}&sortBy=Recommended`,
                '_blank',
              );
              setCurrentStep('complete');
              setShowModal(false);
            }
          }}
          steps={[
            {
              name: 'accreditation_status',
              options: [
                { name: 'Accredited', text: 'YES', value: true },
                { name: 'Non-Accredited', text: 'NO', value: false },
              ],
              title: 'Are you an accredited investor?',
            },
            {
              name: 'alternative_assets_allocation',
              options: [
                { name: '< $1,000', text: '< $1,000', value: 1000 },
                { name: '$1,000 - $10,000', text: '$1,000 - $10,000', value: 10000 },
                { name: '$10,000 - $100,000', text: '$10,000 - $100,000', value: 100000 },
                { name: '$1,000,000+', text: '$1,000,000+', value: 1000000 },
              ],
              title: 'How much are you looking to invest?',
            },
          ]}
        />
      </Modal>
    </AltsFormContainer>
  );
};

const AltsFormContainer = styled.div`
  .success-text {
    font-weight: bold;
    font-style: italic;
  }
`;
